import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { GearFieldWrapper } from '../GearFieldWrapper';
import { MultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';

interface FormMultiSelectProps extends FieldRenderProps {
  onFilterChange?: (value: string) => void;
  onSelectionChange?: (value: any) => void;
}

export const FormMultiSelect: React.FC<FormMultiSelectProps> = fieldRenderProps => {
  const { defaultValue, value, choices, name, disabled, onFilterChange, onSelectionChange } = fieldRenderProps;

  if (!name) {
    return <></>;
  }

  let normalizedDefaultValue = [];

  if (defaultValue) {
    try {
      const deserializedValue = JSON.parse(defaultValue);
      if (Array.isArray(deserializedValue)) {
        normalizedDefaultValue = deserializedValue;
      } else if (deserializedValue) {
        normalizedDefaultValue = [deserializedValue];
      }
    } catch {
      normalizedDefaultValue = [];
    }
  }

  const handleFilterChange = (event: any) => {
    if (onFilterChange) {
      onFilterChange(event.filter.value);
    }
  };

  const handleChange = (event: MultiSelectChangeEvent) => {
    if (onSelectionChange) {
      onSelectionChange(event.target.value);
    }
  };

  return (
    <GearFieldWrapper {...fieldRenderProps}>
      <MultiSelect
        data={choices}
        value={value || normalizedDefaultValue || []}
        onChange={handleChange}
        onFilterChange={handleFilterChange}
        filterable={!!onFilterChange}
        id={fieldRenderProps.name.toString()}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
